module.exports = __webpack_public_path__ + "static/media/NewsItem_Frame_9Slice.b8e60e88.png";